import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { LomaContext } from "src/context/LomaContext";
import { useUserData } from "src/context/userContext";
import { personPvm_getStatusList } from "src/data/personPvmFunctions";
import ProgressBar from "../layout/Progress/ProgressBar";
import { List, ListItem, ListItemButton } from "@mui/material";
import PersonPvmStatusIndicatorBox from "../PersonPvmStatusIndicator/PersonPvmStatusIndicatorBox";

export default function PersonPvmStatusSelector_List({
  statusList: statusList_prop = [],
  onSelect = () => {},
  children,
  selectedStatus,
  disabled = false,
}) {
  const { token, ownerAsiakasId } = useUserData();
  const { statusList: statusList_loma } = useContext(LomaContext) || {};
  const [statusList, setStatusList] = useState();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const asynk = async () => {
      let _statusList = statusList_prop || [];
      if (!_statusList || _statusList.length === 0) _statusList = statusList_loma;
      if (!_statusList || _statusList.length === 0)
        _statusList = await personPvm_getStatusList(ownerAsiakasId, token);
      setStatusList(_statusList);
      setIsLoaded(true);
    };
    asynk();
  }, [statusList_loma]);

  if (!isLoaded) return <ProgressBar />;

  return (
    <List dense>
      {statusList.map((status) => (
        <ListItem
          key={status.personPvmStatusId}
          style={{ display: "flex", alignItems: "center" }}
          disablePadding
          disableGutters>
          <ListItemButton
            disabled={disabled}
            onClick={() => onSelect(status)}
            selected={selectedStatus?.personPvmStatusId === status.personPvmStatusId}>
            <PersonPvmStatusIndicatorBox status={status} />
            {status.personPvmStatus}
          </ListItemButton>
        </ListItem>
      ))}
      {children}
    </List>
  );
}

PersonPvmStatusSelector_List.propTypes = {
  onSelect: PropTypes.func,
  statusList: PropTypes.array,
  children: PropTypes.node,
  selectedStatus: PropTypes.object,
  disabled: PropTypes.bool,
};
